export const playSound = (src) => {
    const isSoundOn = localStorage.getItem("isSoundEnable") === "true";
    if (!isSoundOn) return;
    const audio = new Audio(src);
    audio.volume = 1.0;
    audio.play().catch((err) => {
        console.warn("Audio play failed:", err);
    });
};